import React from "react";

const Container = ({ children, className = "" }) => {
  return (
    <div
      className={`contents position-relative${className ? ` ${className}` : ""}`}
    >
      {children}
    </div>
  );
};

export default Container;
